import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {SettlementStatus, toSettlementStatus} from "./settlement-status";
import {TransportMethod, toTransportMethod } from "./transport-method";

export const CompanySettlementValidator = t.intersection([
  t.type({
    id: t.string,
    settlementId: t.string,
    companyId: t.string,
    method: t.string,
    status: t.string,
    regionId: t.string,
  }),
  t.partial({
    name: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,

    companyName: t.string,
  }),
]);

export const CompanySettlementArrayValidator = t.array(CompanySettlementValidator);

export type CompanySettlement = t.TypeOf<typeof CompanySettlementValidator>;
export type CompanySettlementArray = t.TypeOf<typeof CompanySettlementArrayValidator>;

@Exclude()
export class CompanySettlementEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  name?: string;

  @Expose()
  settlementId!: string;

  @Expose()
  companyId!: string

  @Expose()
  companyName?: string

  @Transform(getDatabaseCodeTransformer(toTransportMethod))
  @Expose()
  method!: TransportMethod;

  @Transform(getDatabaseCodeTransformer(toSettlementStatus))
  @Expose()
  status!: SettlementStatus;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  @Expose()
  regionId!: string

  readonly entityType = 'COMPANY_SETTLEMENT';

  get displayName(): Readonly<string> {
    return this.name ?? this.id;
  }

  /**
   * Constructor for CompanySettlementEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: CompanySettlement): CompanySettlementEntity {
    return plainToInstance(CompanySettlementEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<CompanySettlement> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(CompanySettlementValidator, object);
  }

  asTypeValue(): CompanySettlement {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(CompanySettlementValidator, object);
  }
}

export interface CompanySettlementMapTtasCriteria {
  id: string
  mappingFileId: string,
  companyId?: string
  file: File | null
  objectDocumentAssocId?: string
}
